import SavingThrowRowSmallBoxSvg from './SavingThrowRowSmallBoxSvg';

export default SavingThrowRowSmallBoxSvg;
